/* eslint-disable quotes */
export const booomGames = [
  {
    votableDisabled: "",
    id: "67480",
    tags: "卡牌/战棋/经营模拟/单人联网",
    title: `下班时间`,
    downloadLink: "https://pan.baidu.com/s/1dAoVrTzmCCf2vuZBSJsyWQ",
    downloadPwd: "qmd6",
  },
  {
    votableDisabled: "",
    id: "67477",
    tags: "俯视角/动作/2D像素",
    title: `EGGE`,
    downloadLink: "https://pan.baidu.com/s/1DIRMu0fNmCQjRNvU4-XuHw",
    downloadPwd: "hclh",
  },
  {
    votableDisabled: "",
    id: "67475",
    tags: "平台跳跃/单人",
    title: `时之石`,
    downloadLink: "",
    downloadPwd: "",
  },
  {
    votableDisabled: "",
    id: "67496",
    tags: "解谜/单人",
    title: `DEAR ANNA`,
    downloadLink: "https://pan.baidu.com/s/1FRiUC2aGIhlirYsc16LrSw",
    downloadPwd: "3rlo",
  },
  {
    votableDisabled: "",
    id: "67468",
    tags: "单人 文字 养成",
    title: `18天`,
    downloadLink: "https://pan.baidu.com/s/1CpZ9BEESx_-P7o03ntOB3g",
    downloadPwd: "n1b5",
  },
  {
    votableDisabled: "",
    id: "67487",
    tags: "日本战国，卡牌",
    title: `生命余烬 (Lives' Ember)`,
    downloadLink: "https://pan.baidu.com/s/1Ti2cHgmvhB38HfIFwCrdKQ",
    downloadPwd: "73hm",
  },
  {
    votableDisabled: "",
    id: "67478",
    tags: "解谜类游戏",
    title: `Line Time`,
    downloadLink: "https://pan.baidu.com/s/1ZdPtmebSMnDmvCSqyjEDhA",
    downloadPwd: "tbo3",
  },
  {
    votableDisabled: "",
    id: "67491",
    tags: "单人 · 策略",
    title: `无尽漫游2021`,
    downloadLink: "https://pan.baidu.com/s/1Pw8tbWX3sTW68F3B0pW0YA",
    downloadPwd: "la2f",
  },
  {
    votableDisabled: "",
    id: "67490",
    tags: "科幻/解密/单人",
    title: `TIMEMoRY`,
    downloadLink: "https://pan.baidu.com/s/1qbYUorVQQ0eTxTj6RjP95Q",
    downloadPwd: "0i4d",
  },
  {
    votableDisabled: "",
    id: "67466",
    tags: "单人/棋盘游戏/视觉小说",
    title: `《伟大之路（The Way To Greatness）》`,
    downloadLink: "https://pan.baidu.com/s/1iTSZOjslx_uTBntqblil8g",
    downloadPwd: "nuti",
  },
  {
    votableDisabled: "",
    id: "67461",
    tags: "单人/解密/剧情",
    title: `《Deja Vu 诡迹》`,
    downloadLink: "",
    downloadPwd: "",
  },
  {
    votableDisabled: "",
    id: "67515",
    tags: "奇幻 / 冒险解密 / 单人",
    title: `AtβЫla`,
    downloadLink: "https://pan.baidu.com/s/1IwhotFcnVZFy1-LkdY_-cg",
    downloadPwd: "bv60",
  },
  {
    votableDisabled: "",
    id: "67482",
    tags: "科幻/废土/平台动作/逆向战斗",
    title: `saiko`,
    downloadLink: "https://pan.baidu.com/s/1AAIeyluoST31I7S6jzCgdg",
    downloadPwd: "aojt",
  },
  {
    votableDisabled: "",
    id: "67457",
    tags: "平台动作射击，对战，双人",
    title: `狂乱`,
    downloadLink: "https://pan.baidu.com/s/1PnNdtEzHKBAnPCqA_1JH9Q",
    downloadPwd: "20k2",
  },
  {
    votableDisabled: "",
    id: "67504",
    tags: "科幻/冒险/单人",
    title: `渡轮上的一千零一夜`,
    downloadLink: "",
    downloadPwd: "",
  },
  {
    votableDisabled: "",
    id: "67488",
    tags: "收集/合成/单人",
    title: `《历史制造局》`,
    downloadLink: "https://pan.baidu.com/s/1j73hWfd3Mb5T46udchy7AA",
    downloadPwd: "ijnh",
  },
  {
    votableDisabled: "",
    id: "67511",
    tags: "单人 rpg 游戏",
    title: `轮回模拟器`,
    downloadLink: "https://pan.baidu.com/s/1SpaP41RIJjuchUKg_pw6AA",
    downloadPwd: "lufj",
  },
  {
    votableDisabled: "",
    id: "67493",
    tags: "科幻题材，平台解密类，单人",
    title: `Long Live`,
    downloadLink: "https://pan.baidu.com/s/1Wg07EqMCjwCa_-ExF2_t5g",
    downloadPwd: "tplr",
  },
  {
    votableDisabled: "",
    id: "67512",
    tags: "科幻,类银河城",
    title: `迷时`,
    downloadLink: "https://pan.baidu.com/s/1FuOxBpzy0btnpoRqCJdSkQ",
    downloadPwd: "ef3e",
  },
  {
    votableDisabled: "",
    id: "67500",
    tags: "单人解谜游戏",
    title: `Time is an Illusion`,
    downloadLink: "https://pan.baidu.com/s/1e_UCCfHJhv9P5poqsGFPGw",
    downloadPwd: "o62o",
  },
  {
    votableDisabled: "",
    id: "67503",
    tags: "人生模拟/垃圾分类/单人",
    title: `《时光如幻 岁月如梭》—00后的小明`,
    downloadLink: "https://pan.baidu.com/s/1dbe92x78lF0XyrD-9NNqRA",
    downloadPwd: "pukl",
  },
  {
    votableDisabled: "",
    id: "67460",
    tags: "冒险",
    title: `CoCo&TBall（抠抠和踢爆）`,
    downloadLink: "https://pan.baidu.com/s/1HZ9faZ0-_EBHMLfqFr0SSg",
    downloadPwd: "o7c4",
  },
  {
    votableDisabled: "",
    id: "67467",
    tags: "单人，治愈，策略，解谜，禅游戏",
    title: `Moments`,
    downloadLink: "https://pan.baidu.com/s/12pPNngKBOpkysK8FuXc3UQ",
    downloadPwd: "44vv",
  },
  {
    votableDisabled: "",
    id: "67463",
    tags: "单人横板过关",
    title: `Agent Who`,
    downloadLink: "https://pan.baidu.com/s/1L1qsbn-rJ8jLJIhvt93bKQ",
    downloadPwd: "qgs6",
  },
  {
    votableDisabled: "",
    id: "67465",
    tags: "模拟经营/模拟/单人",
    title: `时光山谷（TimeValley）`,
    downloadLink: "https://pan.baidu.com/s/15VXGOOeBfSSwAFCybD-2kg",
    downloadPwd: "g14o",
  },
  {
    votableDisabled: "",
    id: "67506",
    tags: "单人、科幻、星际、冒险、解谜、2D",
    title: `异星时劫`,
    downloadLink: "https://pan.baidu.com/s/1fnZ8LIoj9chodkejojm6bA",
    downloadPwd: "fvb1",
  },
  {
    votableDisabled: "",
    id: "67497",
    tags: "推箱子，单人操作类游戏",
    title: `宝石猎人Gem Hunter`,
    downloadLink: "https://pan.baidu.com/s/1PDHwnS7_ex5uKnoNVBMrAw",
    downloadPwd: "isg6",
  },
  {
    votableDisabled: "",
    id: "67473",
    tags: "冒险",
    title: `你的日记`,
    downloadLink: "https://pan.baidu.com/s/1O-6PZ1-OCoqzoLz_-HoAuw",
    downloadPwd: "ik62",
  },
  {
    votableDisabled: "放弃评选",
    id: "67464",
    tags: "冒险，单人，解谜",
    title: `离开`,
    downloadLink: "https://pan.baidu.com/s/1fGbCbSO6os4xYelnv3H5YA",
    downloadPwd: "wi96",
  },
  {
    votableDisabled: "",
    id: "67514",
    tags: "横板解谜战斗过关",
    title: `GANDER COMPANY`,
    downloadLink: "https://pan.baidu.com/s/1sCtpThuHyElAaaATHNW8Vw",
    downloadPwd: "c7cm",
  },
  {
    votableDisabled: "",
    id: "67494",
    tags: " 现代 情感 悬疑 冒险/冒险解密类游戏 /单人",
    title: `《回廊》`,
    downloadLink: "https://pan.baidu.com/s/1uJvlnPAJTV4zzxEWSVrZog",
    downloadPwd: "6vvs",
  },
  {
    votableDisabled: "",
    id: "67492",
    tags: "奇幻/2D平台跳跃/单人",
    title: `时之塔`,
    downloadLink: "https://pan.baidu.com/s/1zOQT4ups_CGeSNxP-cpXTQ",
    downloadPwd: "2qa9",
  },
  {
    votableDisabled: "",
    id: "67452",
    tags: "平台解谜/单人",
    title: `无时四季`,
    downloadLink: "https://pan.baidu.com/s/1LRKPLJfc01ALKErJuU0fmA",
    downloadPwd: "4vm5",
  },
  {
    votableDisabled: "",
    id: "67486",
    tags: "科幻 / 单人 / 动作 / 解谜",
    title: `Illusory`,
    downloadLink: "https://pan.baidu.com/s/1yHB96T1FQ-QO6THyFlBMlQ",
    downloadPwd: "le5s",
  },
  {
    votableDisabled: "",
    id: "67479",
    tags: "解谜",
    title: `追忆之章`,
    downloadLink: "https://pan.baidu.com/s/1Wx-8ZdZoJERFQkhjl85Vig",
    downloadPwd: "sv0n",
  },
  {
    votableDisabled: "",
    id: "67469",
    tags: "角色扮演，单人，轻度科幻",
    title: `幻觉`,
    downloadLink: "https://pan.baidu.com/s/1LBxw3YU5MDmHRGociScZog",
    downloadPwd: "jmbm",
  },
  {
    votableDisabled: "",
    id: "67513",
    tags: "",
    title: `Restart（重开算了）`,
    downloadLink: "https://pan.baidu.com/s/1coII3ar4j1l4Jw-INK4PPQ",
    downloadPwd: "fh0n",
  },
  {
    votableDisabled: "",
    id: "67516",
    tags: "单人解密 ",
    title: `《关于星期六这个工作日》 `,
    downloadLink: "https://pan.baidu.com/s/1P0kFxsWQLEFXafixyK-B9Q",
    downloadPwd: "3k3f",
  },
  {
    votableDisabled: "",
    id: "67510",
    tags: "单人/冒险/科幻/严肃游戏/后朋克/Synthwave",
    title: `时间警探`,
    downloadLink: "https://pan.baidu.com/s/1T6lvH0T5WeenoW0oXIrklw",
    downloadPwd: "mvck",
  },
  {
    votableDisabled: "",
    id: "67470",
    tags: "动作、射击、弹幕、单人",
    title: `LOOPER`,
    downloadLink: "https://pan.baidu.com/s/1CzbRxexe0BywhkNJEIrZrQ",
    downloadPwd: "6o9a",
  },
  {
    votableDisabled: "",
    id: "67495",
    tags: "科幻 平台跳跃 单人",
    title: `时间下沉`,
    downloadLink: "https://pan.baidu.com/s/1g1UAKju98bTADLNFy4JqQQ",
    downloadPwd: "hhg4",
  },
  {
    votableDisabled: "",
    id: "67489",
    tags: "游戏类型：益智解谜，单人，讽刺",
    title: `illusionary Time of America`,
    downloadLink: "https://pan.baidu.com/s/1GsC38Me_aO2PxvynK1HUEw",
    downloadPwd: "he2a",
  },
  {
    votableDisabled: "不想参与线上评奖了",
    id: "",
    tags: "第三人称视角/担任/冒险",
    title: `幻影时间 ILLUSION TIME`,
    downloadLink: "",
    downloadPwd: "",
  },
  {
    votableDisabled: "",
    id: "67476",
    tags: "2d平台跳跃/解密/担任",
    title: `零之秘境`,
    downloadLink: "https://pan.baidu.com/s/1mxREurXV8MGJB7AJHQ5edg",
    downloadPwd: "knwb",
  },
  {
    votableDisabled: "",
    id: "67499",
    tags: "弹幕射击+解密，单人单机",
    title: `时间线X`,
    downloadLink: "https://pan.baidu.com/s/1J7Jdr6u_Vmx7X_bLjwFX_Q",
    downloadPwd: "pr3g",
  },
  {
    votableDisabled: "",
    id: "67481",
    tags: "悬疑/解谜/单人",
    title: `无常`,
    downloadLink: "https://pan.baidu.com/s/1PXPxMftCZBrX7ERWGrdpfw",
    downloadPwd: "g6mg",
  },
  {
    votableDisabled: "",
    id: "67474",
    tags: "休闲/平台跳跃/单人",
    title: `TrickyCat
  关于猫是捣乱还是报恩这件事也许是个幻觉`,
    downloadLink: "https://pan.baidu.com/s/1MS2aNf1-jAnaDy-mXRYdlA",
    downloadPwd: "ai31",
  },
  {
    votableDisabled: "",
    id: "67501",
    tags: "第一人称单人解谜",
    title: `帧（The Frame）`,
    downloadLink: "https://pan.baidu.com/s/1y7GmQjJG2HwXH5wcA_l_jQ",
    downloadPwd: "dmh3",
  },
  {
    votableDisabled: "",
    id: "67484",
    tags: "冒险，单人",
    title: `《别忘了遛狗！》`,
    downloadLink: "https://pan.baidu.com/s/1NiEvo_bZCym19MA6BBGvnw",
    downloadPwd: "aiib",
  },
  {
    votableDisabled: true,
    id: "67518",
    tags: "2D俯视角、解谜、科幻、单人",
    title: `Interstice`,
    downloadLink: "https://pan.baidu.com/s/16L745HWqlOraG_Z1Iypnng",
    downloadPwd: "vbe5",
  },
  {
    votableDisabled: "",
    id: "67517",
    tags: "俯视角 双人合作 动作 rpg 冒险 悬疑 科幻 魔幻 冒险",
    title: `十二地支`,
    downloadLink: "https://pan.baidu.com/s/1BOuQpE79k8FurJbXNEgTBw",
    downloadPwd: "lokk",
  },
  {
    votableDisabled: "",
    id: "67578",
    tags: "玩法探索",
    title: `Time for lunch`,
    downloadLink: "https://pan.baidu.com/s/1tTTA-aIBtVT1cxf3ElhAkA",
    downloadPwd: "rtv8",
  },
  {
    votableDisabled: "",
    id: "67458",
    tags: "•  奇幻 / 冒险 / 平台跳跃 / 解迷 / 单人 / 隐藏关卡",
    title: `KEEK`,
    downloadLink: "https://pan.baidu.com/s/1YkaZJWnlplEjhaxgtX_p9Q",
    downloadPwd: "9b78",
  },
  {
    votableDisabled: "",
    id: "67471",
    tags: "奇幻 / 音游 / 单人",
    title: `溯音`,
    downloadLink: "https://pan.baidu.com/s/1DvPaL64T_-aqF1J_KX-ebQ",
    downloadPwd: "n5an",
  },
  {
    votableDisabled: "",
    id: "67483",
    tags: "音游",
    title: `Time Melody`,
    downloadLink: "https://pan.baidu.com/s/1CWDPFItfmAm7hYADej9Jig",
    downloadPwd: "m3mc",
  },
  {
    votableDisabled: "",
    id: "67459",
    tags: "单人解密",
    title: `《小咪》`,
    downloadLink: "https://pan.baidu.com/s/1UMOQSq7sQVrTvBBbpJaxCQ",
    downloadPwd: "ke7r",
  },
  {
    votableDisabled: "",
    id: "67509",
    tags: "策略游戏/游玩人数：一人",
    title: `噩梦`,
    downloadLink: "https://pan.baidu.com/s/1Kl6HSWUYSWyothm74iJlpA",
    downloadPwd: "impc",
  },
  {
    votableDisabled: "",
    id: "67455",
    tags: "益智/休闲/单人",
    title: `GAMEAGE`,
    downloadLink: "https://pan.baidu.com/s/1nfxMIprC2Hhv9bWymn53-A",
    downloadPwd: "hb86",
  },
  {
    votableDisabled: "",
    id: "67502",
    tags: "3D动作冒险",
    title: `绝对空间`,
    downloadLink: "https://pan.baidu.com/s/1Jh00GMtBC71fNdS0aHtlXA",
    downloadPwd: "trt1",
  },
  {
    votableDisabled: "",
    id: "67579",
    tags: "单人，体验，实验性",
    title: `时间的形状`,
    downloadLink: "",
    downloadPwd: "",
  },
  {
    votableDisabled: "",
    id: "67462",
    tags: "单人/文字冒险",
    title: `《猫咪酒馆》`,
    downloadLink: "https://pan.baidu.com/s/1d54toflukmA_wBqZ2Oi1xg",
    downloadPwd: "tndu",
  },
  {
    votableDisabled: "不参与评奖",
    id: "67485",
    tags: "类三消RPG",
    title: `The Devil Max`,
    downloadLink: "https://pan.baidu.com/s/1zpCGOKsS-TKpo_2nTayXcw",
    downloadPwd: "gufs",
  },
  {
    votableDisabled: "",
    id: "67505",
    tags: "单人，冒险",
    title: `Time of Fugue`,
    downloadLink: "https://pan.baidu.com/s/1yjCVd3CLK5xJ91p1JslNAA",
    downloadPwd: "mbpd",
  },
  {
    votableDisabled: "",
    id: "67453",
    tags: "科幻 太空 解谜 冒险 叙事 单人",
    title: `《露西日记（上）》`,
    downloadLink: "https://pan.baidu.com/s/1skkScP-tg7rSm56C2UbJzQ",
    downloadPwd: "7n7h",
  },
  {
    votableDisabled: "",
    id: "67456",
    tags: "单人解谜",
    title: `Gray summer`,
    downloadLink: "https://pan.baidu.com/s/1k40rVZ5K-QvoxYYi71VQLA",
    downloadPwd: "wvuq",
  },
  {
    votableDisabled: "",
    id: "67508",
    tags: "blaster/冒险/单人",
    title: `peneo`,
    downloadLink: "https://pan.baidu.com/s/1vLAYXjtujOavtOIJLLeR_A",
    downloadPwd: "lgvc",
  },
  {
    votableDisabled: "",
    id: "67498",
    tags: "魔幻/策略解谜/单人",
    title: `Time Ring`,
    downloadLink: "https://pan.baidu.com/s/1c9K7pfa-r208eo32sUrL-w",
    downloadPwd: "ruob",
  },
  {
    votableDisabled: "",
    id: "67472",
    tags: "梦境/随机叙事/解谜/单人",
    title: `Floating Along Dream
  夜长梦多，随梦漂流吧`,
    downloadLink: "https://pan.baidu.com/s/1ZLgUBJoJUSNM6eKr1I0spw",
    downloadPwd: "veru",
  },
  {
    votableDisabled: "放弃评选",
    id: "67580",
    tags: "文字冒险/单人",
    title: `夏日的朋友`,
    downloadLink: "https://pan.baidu.com/s/1ZsN8ndq9B4w7nFm2sIkAXA",
    downloadPwd: "g2sm",
  },
  {
    votableDisabled: "放弃评选",
    id: "67721",
    tags: "",
    title: `只有两回合`,
    downloadLink: "https://pan.baidu.com/s/1gQZRu5ehsh50dM2Sh-pxtQ",
    downloadPwd: "oki6",
  },
]
  .filter(game => game.id)
  .map(game => {
    const tags = game.tags.split(/[. ·•,，/、]+/).filter(tag => tag)
    return {
      ...game,
      tags: [...new Set(tags)],
      votableDisabled: !!game.votableDisabled,
    }
  })
export const booomGameIds = booomGames.map(g => g.id)
export const booomGameVotableIds = booomGames
  .filter(g => !g.votableDisabled)
  .map(g => g.id)
export const booomGameUnvotableIds = booomGames
  .filter(g => g.votableDisabled)
  .map(g => g.id)
